






import { defineComponent } from '@vue/composition-api';

import PanelWithSessionEditor from '@/components/Live/PanelWithSessionEditor.vue';

const New = defineComponent({
  components: {
    PanelWithSessionEditor,
  },
  // setup() {},
});

export default New;
